<ng-container *transloco="let rootT">
  <ng-container *transloco="let t; scope: 'app-shell'; prefix: 'app-shell'">
    <de-navbar
      [brandHref]="t('appNavbar.brand.homeUrl')"
      brandIconWidth="2.5rem"
      brandIconHeight="2rem"
      [brandLabel]="t('appNavbar.title', { appName: title() })"
      [brandAriaLabel]="t('appNavbar.brand.homeLabel')"
    >
      <img
        deNavbarBrandIcon
        ngSrc="/assets/docestate_logo.svg"
        width="74"
        height="51"
        alt=""
        class="app-navbar__brand-logo"
      />

      <div class="app-navbar__menu">
        <de-button
          type="button"
          class="app-navbar__menu-toggle"
          variant="tertiary"
          color="light"
          leftIconClass="bi-list"
          (buttonClick)="toggleMenu()"
        >
          <span class="visually-hidden">{{ t('appNavbar.actions.menu') }}</span>

          @if (showDashboardNavbarActions() && hasMessageUnreadBadge() && !menuOpen()) {
            <span class="app-navbar__message-badge app-navbar__message-badge--menu" aria-hidden="true">
              {{ messageUnreadBadgeLabel() }}
            </span>
          }
        </de-button>

        <div class="app-navbar__actions" [class.app-navbar__actions--open]="menuOpen()">
          @if (showDashboardNavbarActions()) {
            <de-button
              type="button"
              class="app-navbar__message-action"
              variant="tertiary"
              color="light"
              rightIconClass="bi-chat-dots fs-5"
              (buttonClick)="openMessages()"
            >
              {{ t('appNavbar.actions.message') }}

              @if (hasMessageUnreadBadge()) {
                <span class="app-navbar__message-badge" aria-hidden="true">
                  {{ messageUnreadBadgeLabel() }}
                </span>
              }
            </de-button>

            <de-button
              type="button"
              variant="tertiary"
              color="light"
              (buttonClick)="openNewRequest()"
            >
              {{ t('appNavbar.actions.newRequest') }}
            </de-button>
          }

          <de-select
            class="app-navbar__language-select"
            inputId="app-language"
            [ariaLabel]="rootT('appNavbar.languageSwitcher.label')"
            leftIconClass="bi-globe2"
            [options]="languageOptions()"
            [selectedDisplayLabel]="selectedLanguageShortLabel()"
            [showPlaceholderOption]="false"
            [value]="currentLanguage()"
            (valueChange)="changeLanguage($event)"
          />
        </div>
      </div>
    </de-navbar>
  </ng-container>
</ng-container>
